// extracted by mini-css-extract-plugin
export var contentContainer = "search-drawer-module--contentContainer--ffb70";
export var details = "search-drawer-module--details--b2ac7";
export var inner = "search-drawer-module--inner--395dc";
export var input = "search-drawer-module--input--37379";
export var noticeBarVisible = "search-drawer-module--noticeBarVisible--877d6";
export var product = "search-drawer-module--product--9ea67";
export var productTitle = "search-drawer-module--productTitle--0b04c";
export var results = "search-drawer-module--results--84bec";
export var searchDrawer = "search-drawer-module--searchDrawer--f9caa";
export var shop = "search-drawer-module--shop--9a844";
export var thumbnail = "search-drawer-module--thumbnail--85d38";
export var thumbnailImage = "search-drawer-module--thumbnailImage--d2be6";
export var titlePrice = "search-drawer-module--titlePrice--47142";